import BaseAPI from "@/api/BaseAPI";

export class FilesAPI extends BaseAPI {
  constructor() {
    super('/file');
  }

  /**
   * @param {FormData} data
   * @param {string} scanType
   * @param {string} description
   * @param {string} userId
   * @param {'founderID' | 'regionID' | 'orgID'} userType
   * */
  saveFile(data, scanType = '', description = '', userType = 'orgID', userId = '') {
    return this.http.put(`/upload?scanType=${scanType}&description=${description}&userType=${userType}&userId=${userId}`, {data})
  }

  /**
   * @param {String} id
   * */
  getFile(file) {
    return this.http.get('/download', {data: {file}})
  }

  getPril(orgId, prilNum){
    return this.http.get(`/prilPrikaz?orgId=${orgId}&prilId=${prilNum}`)
  }

  /**
   * @param {String} path
   * */
  // getReport(path){
  //     return this.http.et(path)
  // }
  /**
   * @param {String} id
   * */
  deleteFile(id) {
    return this.http.delete('/delete', {data: {fileId: id}})
  }

  /**
   * @param {string} userId
   * @param {'founderID' | 'regionID' | 'orgID'} userType
   * */
  getFileList(userType, userId) {
    return this.http.get('/list', {data: {userType, userId}})
  }

}

export default new FilesAPI();